import { styled } from "goober";
import { type ComponentProps, useState } from "react";
import { Dropdown } from "./Dropdown";
import { Icon, type IconName } from "./Icon";
import { Tooltip } from "./Tooltip";
import { WorkflowNavigationButton } from "./WorkflowNavigationButton";

export const FeatureButton = styled(WorkflowNavigationButton)`
  justify-content: center;

  && {
    border: none;
    border-radius: 999px;
    background: var(--alpha4);
  }

  &&:hover,
  &&:focus-visible,
  [data-dropdown-open="true"] && {
    background: var(--alpha8);
  }
`;

const FeatureIcon = styled("span")`
  position: relative;
  display: inline-flex;

  & > span {
    display: inline-flex;
  }

  &[data-active="true"] > span {
    mask-image: radial-gradient(
      circle at calc(100% - 2px) calc(100% - 2px),
      transparent 4px,
      #000 4px
    );
  }

  &[data-active="true"]::after {
    content: "";
    position: absolute;
    right: -1px;
    bottom: -1px;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: var(--green-600);
  }
`;

export function WorkflowFeatureButton({
  label,
  icon,
  isOn,
  sections,
  target,
}: {
  label: string;
  icon: IconName;
  isOn: boolean;
  sections: ComponentProps<typeof Dropdown>["sections"];
  target: string;
}) {
  const [open, setOpen] = useState(false);
  return (
    <Dropdown
      align="bottom-left"
      target={target}
      matchOpenerWidth
      margin="4px 0"
      onOpenChange={setOpen}
      opener={
        <Tooltip
          fill="stretch"
          hidden={open}
          content={`${label} · ${isOn ? "On" : "Off"}`}
        >
          <FeatureButton
            data-no-pill
            aria-label={label}
            aria-description={isOn ? "On" : "Off"}
            aria-haspopup="menu"
            aria-expanded={open}
          >
            <FeatureIcon data-active={isOn} aria-hidden="true">
              <span>
                <Icon
                  name={icon}
                  size={16}
                  style={{
                    opacity: isOn ? 1 : 0.4,
                    transition: "opacity var(--motion-fast) var(--ease-out)",
                  }}
                />
              </span>
            </FeatureIcon>
          </FeatureButton>
        </Tooltip>
      }
      sections={sections}
    />
  );
}
